import { render, staticRenderFns } from "./inloggen.vue?vue&type=template&id=227509e6&"
import script from "./inloggen.vue?vue&type=script&lang=js&"
export * from "./inloggen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsLogo: require('/home/plantenkennistrainer/vhg-plantenkennistrainer/trainer/components/icons/Logo.vue').default,IconsPlantsCollection: require('/home/plantenkennistrainer/vhg-plantenkennistrainer/trainer/components/icons/PlantsCollection.vue').default})
